module.exports = __webpack_public_path__ + "static/media/gtf-crew-subhero.9953d077.png";